
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor()
    export class TestResultCodeEditor extends Serenity.Select2Editor<any, any> {
        constructor(container: JQuery, opt: any) {
            super(container, opt?.multiple ? { multiple: true } : null);

            this.addItem({ id: "PASS", text: "PASS" });
            this.addItem({ id: "FAIL", text: "FAIL" });
            this.addItem({ id: "WARN", text: "WARN" });
            this.addItem({ id: "IGNORE", text: "IGNORE" });

        }
    }
}